import instance from "../../services/baseService";

export const getActivityList = async (page = 1, perpage = 25, start_date) => {
    try {
        const response = await instance.post(`/api/v1/log/lists`, {
            page,
            perpage,
            start_date
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching assigned users list:', error);
        throw error;
    }
};